import token, { tokenToVars } from '../token';
import Textarea from './textarea';

export { Textarea };
export default tokenToVars(Textarea, token);
